import * as React from 'react';
import { IField } from './utils';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import FormikNumberFormatter from './formik-number-formatter';

import { FormikProps } from 'formik';

const UsdNumberFormat = (props: any) => {
  const { inputRef, onChange, ...other } = props;

  const handleValueChange = (values: NumberFormatValues) => {
    onChange({
      target: {
        value: values.value
      }
    });
  };

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={handleValueChange}
      thousandSeparator
      prefix="$"
    />
  );
};

interface IProps {
  field: IField;
  form: FormikProps<any>;
  label: string;
}

const FormikUsdFormat = (props: IProps) => {
  const { field, form, label, ...other } = props;

  return (
    <FormikNumberFormatter
      field={field}
      form={form}
      label={label}
      numberFormatter={UsdNumberFormat}
      {...other}
    />
  );
};

export default FormikUsdFormat;



// WEBPACK FOOTER //
// ./src/common/formik/formik-usd-format.tsx